<template>
	<el-form :disabled="onlyRead">
		<el-form-item label="数据类型:" label-width="120px">
			<el-tag>对象数组</el-tag>
		</el-form-item>
		<el-form-item label="长度:" label-width="120px">
			<el-input v-model="specs.size"></el-input>
		</el-form-item>
	</el-form>
	<el-divider content-position="center">字段:</el-divider>
	<el-tabs tab-position="left">
		<el-tab-pane v-for="item in specs.item.specs" :label="item.identifier">
			<intAttr :onlyRead="onlyRead" :specs="item.dataType.specs" v-if="item.dataType.type =='int'"></intAttr>
			<boolAttr :onlyRead="onlyRead" :specs="item.dataType.specs" v-if="item.dataType.type =='bool'"></boolAttr>
			<textAttr :onlyRead="onlyRead" :specs="item.dataType.specs" v-if="item.dataType.type =='text'"></textAttr>
			<enumAttr :onlyRead="onlyRead" :specs="item.dataType.specs" v-if="item.dataType.type =='enum'"></enumAttr>
			<structAttr :onlyRead="onlyRead" :specs="item.dataType.specs" v-if="item.dataType.type =='struct'">
			</structAttr>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import intAttr from '../../../components/tsl/attribute/int.vue'
	import boolAttr from '../../../components/tsl/attribute/bool.vue'
	import enumAttr from '../../../components/tsl/attribute/enum.vue'
	import textAttr from '../../../components/tsl/attribute/text.vue'
	import structAttr from '../../../components/tsl/attribute/struct.vue'
	export default {
		name: 'arrayStruct',
		mixins: [],
		components: {
			intAttr,
			boolAttr,
			enumAttr,
			textAttr,
			structAttr
		},
		props: ['specs', 'onlyRead'],
		data() {
			return {
				dataType: {
					'int': "数值",
					'bool': "布尔值",
					'enum': "枚举",
					'text': "字符串",
					'struct': "对象"
				}
			}
		}
	}
</script>

<style>
</style>
